import { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { Col, Row, DatePicker, Button, Space, Select, Input } from "antd";
import { SearchOutlined, ReloadOutlined } from "@ant-design/icons";
import dayjs, { Dayjs } from "dayjs";
import PriceAuditContext from "../../../context/price-audit/context";
import styles from "./styles.module.scss";

const { RangePicker } = DatePicker;

interface IProps {
  onFilter?: () => void;
}

const PriceAuditFilter: React.FC<IProps> = ({ onFilter }) => {
  const { t } = useTranslation();
  const { query, actions } = useContext(PriceAuditContext);
  const [dateRange, setDateRange] = useState<[Dayjs | null, Dayjs | null]>([
    null,
    null,
  ]);
  const [postPaymentOnly, setPostPaymentOnly] = useState<boolean | undefined>(
    undefined
  );
  const [orderId, setOrderId] = useState<string>("");

  const postPaymentOptions = [
    { label: t("all"), value: undefined },
    { label: t("post_payment_only"), value: true },
    { label: t("pre_payment_only"), value: false },
  ];

  const handleFilter = () => {
    const from_date = dateRange[0]
      ? dateRange[0].format("YYYY-MM-DD")
      : undefined;
    const to_date = dateRange[1] ? dateRange[1].format("YYYY-MM-DD") : undefined;

    actions.setQuery({
      ...query,
      page: 1,
      from_date,
      to_date,
      payment_confirmed_only: postPaymentOnly,
      order_id: orderId ? Number(orderId) : undefined,
    });

    if (onFilter) {
      onFilter();
    }
  };

  const handleReset = () => {
    setDateRange([null, null]);
    setPostPaymentOnly(undefined);
    setOrderId("");
    actions.setQuery({
      page: 1,
      per_page: query?.per_page || 10,
    });

    if (onFilter) {
      onFilter();
    }
  };

  return (
    <div className={styles.container}>
      <Row gutter={[16, 16]} align="middle">
        <Col xs={24} sm={24} md={8} lg={6}>
          <label className={styles.label}>{t("date_range")}</label>
          <RangePicker
            value={dateRange}
            onChange={(dates) =>
              setDateRange(dates as [Dayjs | null, Dayjs | null])
            }
            style={{ width: "100%" }}
            placeholder={[t("from_date"), t("to_date")]}
          />
        </Col>
        <Col xs={24} sm={12} md={6} lg={4}>
          <label className={styles.label}>{t("payment_status")}</label>
          <Select
            value={postPaymentOnly}
            onChange={(value) => setPostPaymentOnly(value)}
            options={postPaymentOptions}
            style={{ width: "100%" }}
            placeholder={t("select_payment_status")}
            allowClear
          />
        </Col>
        <Col xs={24} sm={12} md={4} lg={4}>
          <label className={styles.label}>{t("order_id")}</label>
          <Input
            value={orderId}
            onChange={(e) => setOrderId(e.target.value)}
            placeholder={t("enter_order_id")}
            type="number"
          />
        </Col>
        <Col xs={24} sm={12} md={6} lg={6}>
          <div className={styles.buttons}>
            <Space>
              <Button
                type="primary"
                icon={<SearchOutlined />}
                onClick={handleFilter}
              >
                {t("filter")}
              </Button>
              <Button icon={<ReloadOutlined />} onClick={handleReset}>
                {t("reset")}
              </Button>
            </Space>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default PriceAuditFilter;
